console.log('js/marketing.js -> v0.1.0');
const marketing = (function() {
	return {

		/**
		 * The values are used in GTM, do not change them.
		 */
		SoftGoals:  {
			Referral: 'referral',
			AccountRegistration: 'account_registration',
			NewsletterSubscription: 'newsletter_subscription',
			AddToWishlist: 'AddToWishlist'
		},

		/**
		 * Tracks softgoals.
		 * @param {string} softgoalType
		 * @param {string} softgoalSubtype
		 */
		trackSoftGoals: function(softgoalType, softgoalSubtype) {
			gae(softgoalType, softgoalSubtype);
			gae('softgoal', softgoalType);

			window.dataLayer.push({
				'event': 'softgoal',
				'softgoal_type': softgoalType,
				'softgoal_sub_type' : softgoalSubtype
			});
		}
	}
})();
